<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <div class="ListMenu">
        <div class="MenuBtnWrap">
          <div class="btn" @click="$router.push('/activityList')">
            返回活動列表
          </div>
        </div>
      </div>
      <div class="tableWrap">
        <el-table
          height="660px"
          stripe
          :data="activityList"
          style="width: 100%"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in activityTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
                -
              </div>
              <div v-else-if="item.prop === 'free'">
                <div v-if="scope.row.free == 1">是</div>
                <div v-else>否</div>
              </div>
              <div v-else-if="item.prop === 'minPrice'">
                <div v-if="scope.row.free == 1">
                  {{
                    scope.row.minPrice + "CNY / " + scope.row.twdPrice + "TWD"
                  }}
                </div>
                <div v-else>
                  {{ scope.row.freeContent ? scope.row.freeContent : "免費" }}
                </div>
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="140" fixed="right">
            <template slot-scope="scope">
              <el-button
                @click="
                  $router.push(
                    `/editActivity?id=${scope.row.id}&status=${scope.row.status}&pageType=draft`
                  )
                "
                type="text"
                >编辑</el-button
              >
              <el-button @click="delActivity(scope.row.id)" type="text"
                >刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
export default {
  data() {
    return {
      navBlock: "活動 / 活動列表",
      navtitle: "草稿箱",
      activityList: [],
      activityTable: [
        {
          prop: "applyName",
          label: "活動名稱",
          width: "200",
        },
        {
          prop: "applyWay",
          label: "活動類型",
          width: "110",
        },
        {
          prop: "free",
          label: "付費活動",
          width: "80",
        },
        {
          prop: "minPrice",
          label: "活動價格",
          width: "160",
        },
        {
          prop: "updateTime",
          label: "最後更新時間",
          width: "160",
        },
      ],
      currentPage: 1, // 分页
      total: 0,
      dialogVisible: false,
    };
  },
  created() {
    this.getActivityList();
  },

  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取活动列表信息
    getActivityList() {
      let param = {
        pageNo: this.currentPage,
        pageSize: 10,
        drafts: 0,
      };
      this.$post(
        "/request/apply/getApplyList",
        param,
        this.$GLOBAL.jsonConfig
      ).then((res) => {
        if (res.code === "00000") {
          res.data.list.forEach((v) => {
            switch (v.applyWay) {
              case "1":
                v.applyWay = "一般活動";
                break;
              case "2":
                v.applyWay = "演唱會";
                break;
              case "4":
                v.applyWay = "見面會";
                break;
              case "3":
                v.applyWay = "後臺活動";
                break;
            }
            switch (v.applyStatus) {
              case "1":
                v.applyStatus = "未開始階段";
                v.status = "1";
                break;
              case "2":
                v.applyStatus = "報名階段";
                v.status = "2";
                break;
              case "3":
                v.applyStatus = "抽籤階段";
                v.status = "3";
                break;
              case "4":
                v.applyStatus = "付款階段";
                v.status = "4";
                break;
              case "5":
                v.applyStatus = "確認階段";
                v.status = "5";
                break;
            }
            v.updateTime = this.$getTime(v.updateTime);
          });
          this.activityList = res.data.list;
          this.total = res.data.allRow;
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getActivityList();
    },
    // 删除活动
    delActivity(id) {
      let _this = this;
      _this
        .$confirm("是否刪除該草稿?", "提示信息", {
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false,
        })
        .then(() => {
          // 确认删除的回调
          _this
            .$post(
              "/request/apply/deleteApply",
              { applyId: id },
              _this.$GLOBAL.jsonConfig
            )
            .then((res) => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                if (_this.activityList.length == 1 && _this.currentPage > 1) {
                  _this.currentPage--;
                }
                _this.$propMessage("刪除成功", "success", function () {
                  _this.dialogVisible = false;
                  _this.getActivityList();
                });
              } else {
                _this.$propMessage(res.message, "error", function () {
                  _this.dialogVisible = false;
                });
              }
            });
        });
    },
    // 进入修改页面状态
    toEditStatus(id, applyName, type, status, startTime, endTime) {
      if (status === "1") {
        //未开始阶段,携带id、type、status，活动开始、结束时间
        this.$router.push(
          `/editStatus?id=${id}&applyName=${applyName}&type=${type}&status=${status}&startTime=${startTime}&endTime=${endTime}`
        );
      } else if (status === "2") {
        //登记阶段,携带id、type、status、活动结束时间
        this.$router.push(
          `/editStatus?id=${id}&applyName=${applyName}&type=${type}&status=${status}&endTime=${endTime}`
        );
      } else if (status === "3") {
        // 抽签阶段
        this.$router.push(
          `/editStatus?id=${id}&applyName=${applyName}&type=${type}&status=${status}`
        );
      } else if (status === "4") {
        // 确认阶段
        this.$router.push(
          `/editStatus?id=${id}&applyName=${applyName}&type=${type}&status=${status}`
        );
      }
    },
    navigateDraw(res) {
      // if (res.applyStatus == "報名階段") {
      //   let url = `/request/apply/export/excel`;
      //   let date = new Date();
      //   this.$exportExcel(
      //     url,
      //     "POST",
      //     {
      //       applyId: res.id
      //     },
      //     "用戶報名資料" + this.$formatDate(date).substring(0, 10)
      //   );
      //   return;
      // }
      this.$get(
        `/request/apply/getApplyStatus?applyId=${res.id}`,
        this.$GLOBAL.jsonConfig
      ).then((result) => {
        if (result.code == "00000") {
          if (result.data.applyStatus == 2) {
            this.$router.push(
              `/activityDrawFirst?id=${result.data.id}&status=${result.data.applyStatus}`
            );
          }
          if (result.data.applyStatus == "3") {
            if (result.data.jump) {
              //手动抽选页面
              this.$router.push(`/activityDrawList?id=${result.data.id}`);
              this.$bus.$emit("activityDrawinit");
            } else {
              //抽选条件页面

              this.$router.push(
                `/activityDrawFirst?id=${result.data.id}&selectionType=${result.data.selectionType}`
              );
            }
          } else if (result.data.applyStatus == "4") {
            this.$router.push(`/activityDrawConfirmList?id=${result.data.id}`);

            this.$bus.$emit("activityDrawinitList");
            this.$bus.$emit("activityDrawConfirminit");
          } else if (result.data.applyStatus == "5") {
            //最后调整页面
            this.$router.push(`/activityDrawConfirmList?id=${result.data.id}`);
            this.$bus.$emit("activityDrawinitList");
            this.$bus.$emit("activityDrawConfirminit");
            // this.$bus.$emit('activityDrawConfirminitNull')
          }
        } else {
          this.dialogVisible = true;
          this.$propMessage(result.message, "error", () => {
            this.dialogVisible = false;
          });
        }
      });
    },
  },
  components: {
    NavBar,
    DiaMess,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/activity/draftActivityList.vue